import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento_offlineshipping-module"
    }}>{`Magento_OfflineShipping module`}</h1>
    <p>{`This module implements the shipping methods which do not involve a direct interaction with shipping carriers, so called offline shipping methods.
Namely, the following:`}</p>
    <ul>
      <li parentName="ul">{`Free Shipping`}</li>
      <li parentName="ul">{`Flat Rate`}</li>
      <li parentName="ul">{`Table Rates`}</li>
      <li parentName="ul">{`Store Pickup`}</li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Before installing this module, note that the Magento_OfflineShipping is dependent on the following modules:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Store`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Sales`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Quote`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Quote`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_SalesRule`}</inlineCode></li>
    </ul>
    <p>{`The Magento_OfflineShipping module creates the `}<inlineCode parentName="p">{`shipping_tablerate`}</inlineCode>{` table in the database.`}</p>
    <p>{`This module modifies the following tables in the database:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`salesrule`}</inlineCode>{` - adds column `}<inlineCode parentName="li">{`simple_free_shipping`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`sales_order_item`}</inlineCode>{` - adds column `}<inlineCode parentName="li">{`free_shipping`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`quote_address`}</inlineCode>{` - adds column `}<inlineCode parentName="li">{`free_shipping`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`quote_item`}</inlineCode>{` - adds column `}<inlineCode parentName="li">{`free_shipping`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`quote_address_item`}</inlineCode>{` - adds column `}<inlineCode parentName="li">{`free_shipping`}</inlineCode></li>
    </ul>
    <p>{`For information about a module installation in Magento 2, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-operations/installation-guide/tutorials/manage-modules.html"
      }}>{`Enable or disable modules`}</a>{`.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Extension developers can interact with the Magento_OfflineShipping module. For more information about the Magento extension mechanism, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/plugins/"
      }}>{`Magento plug-ins`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/php/development/components/dependency-injection/"
      }}>{`The Magento dependency injection mechanism`}</a>{` enables you to override the functionality of the Magento_OfflineShipping module.`}</p>
    <p>{`A lot of functionality in the module is on JavaScript, use `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/javascript/mixins/"
      }}>{`mixins`}</a>{` to extend it.`}</p>
    <h3 {...{
      "id": "layouts"
    }}>{`Layouts`}</h3>
    <p>{`This module introduces the following layouts in the `}<inlineCode parentName="p">{`view/frontend/layout`}</inlineCode>{` directory:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`checkout_cart_index`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`checkout_index_index`}</inlineCode></li>
    </ul>
    <p>{`For more information about a layout in Magento 2, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/guide/layouts/"
      }}>{`Layout documentation`}</a>{`.`}</p>
    <h3 {...{
      "id": "ui-components"
    }}>{`UI components`}</h3>
    <p>{`This module extends following ui components located in the `}<inlineCode parentName="p">{`view/adminhtml/ui_component`}</inlineCode>{` directory:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`sales_rule_form`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`salesrulestaging_update_form`}</inlineCode></li>
    </ul>
    <p>{`For information about a UI component in Magento 2, see `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/frontend-core/ui-components/"
      }}>{`Overview of UI components`}</a>{`.`}</p>
    <h2 {...{
      "id": "additional-information"
    }}>{`Additional information`}</h2>
    <p>{`You can get more information about offline shipping methods in magento at the articles:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/commerce-admin/stores-sales/delivery/basic-methods/shipping-free.html"
        }}>{`How to configure Free Shipping`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/commerce-admin/stores-sales/delivery/basic-methods/shipping-flat-rate.html"
        }}>{`How to configure Flat Rate`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/commerce-admin/stores-sales/delivery/basic-methods/shipping-table-rate.html"
        }}>{`How to configure Table Rates`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/commerce-admin/stores-sales/delivery/basic-methods/shipping-in-store-delivery.html"
        }}>{`How to configure Store Pickup`}</a></li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 100.4.6.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      